<template>
  <v-container fluid class="template-container">
    <v-row justify="center">
      <div class="text-h1">{{ $t("unAuthorized.text.title") }}</div>
    </v-row>
    <v-row justify="center">
      <div class="text-subtitle-1">{{ $t("unAuthorized.text.describe") }}</div>
    </v-row>
    <v-row justify="center">
      <v-btn color="primary" :to="{ name: 'Login' }">
        {{ $t("general.button.toHome") }}
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PageNotFound",
};
</script>
